module.exports = __webpack_public_path__ + "static/media/product.545d092e.png";